module.exports = __webpack_public_path__ + "static/media/5_13.04311afa.png";